<template>
  <main>
    <header>
      <img src="/assets/color-logo.svg" alt />
      <span>ID #{{ reportId }}</span>
    </header>
    <dl>
      <dt>Prodajno mjesto</dt>
      <dd v-if="seller">{{ seller.firstName }} {{ seller.lastName }}</dd>
      <dt>Za dan</dt>
      <dd>{{ formatDate(from || now) }}</dd>
    </dl>
    <h1>Blagajničko izvješće</h1>
    <p class="sale-period">Izvještaj sastavljen {{ formatDateTime(now) }}</p>
    <table>
      <thead>
        <tr>
          <th>Opis</th>
          <th />
          <th>Iznos (EUR)</th>
        </tr>
      </thead>
      <tbody>
        <tr>
          <td>Polog</td>
          <td />
          <td>100.00</td>
        </tr>
        <tr>
          <td>Ukupni primitak (novčanice)</td>
          <td />
          <td>{{ getTotalSoldAmount(cashReport) }}</td>
        </tr>
        <tr>
          <td>Ukupni primitak (kartice)</td>
          <td />
          <td>{{ getTotalSoldAmount(cardReport) }}</td>
        </tr>
        <tr>
          <td>Ukupni primitak (ostalo)</td>
          <td />
          <td>{{ getTotalSoldAmount(otherReport) }}</td>
        </tr>
      </tbody>
    </table>
  </main>
</template>

<script>
import moment from 'moment'
import { GET_TICKET_SELLERS_REPORT } from '@/graphql/order.graphql'
import { GET_LOGGED_USER } from '@/graphql/user.graphql'
import { OrderStatusEnum } from '@/types'

export default {
  props: {
    from: {
      type: String,
      default: null,
    },
    to: {
      type: String,
      default: null,
    },
  },
  data() {
    return {
      orders: [],
      seller: null,
      totalSoldCount: 0,
      cashReport: [],
      cardReport: [],
      otherReport: [],
      reportId: null,
      now: null,
    }
  },
  methods: {
    formatDate(date) {
      return moment(date).format('DD. MM. YYYY')
    },
    formatDateTime(date) {
      return moment(date).format('DD. MM. YYYY HH:mm')
    },
    getYear(date) {
      return moment(date).year()
    },
    getTotalSoldAmount(reports) {
      return reports
        .reduce((sum, order) => {
          if (['KEKS10'].includes(order.buyer && order.buyer.paymentType)) {
            return sum + parseFloat(order.totalPrice) * 0.9
          }
          if (['TELEGRAM20'].includes(order.buyer && order.buyer.paymentType)) {
            return sum + parseFloat(order.totalPrice) * 0.8
          }
          if (
            ['CASH20', 'CARD20', 'CASH50', 'CARD50'].includes(
              order.buyer && order.buyer.paymentType,
            )
          ) {
            if (order.buyer.paymentType.endsWith('20')) {
              return sum + parseFloat(order.totalPrice) * 0.8
            }

            return sum + parseFloat(order.totalPrice) * 0.5
          }

          return sum + order.totalPrice
        }, 0)
        .toFixed(2)
    },
  },
  apollo: {
    getTicketSellersReport: {
      query: GET_TICKET_SELLERS_REPORT,
      variables() {
        return {
          from: this.from ? this.from : new Date(new Date().setHours(0, 0, 0, 0)).toISOString(),
          to: this.to ? this.to : new Date(new Date().setHours(23, 59, 59, 0)).toISOString(),
        }
      },
      manual: true,
      result({ data, loading }) {
        if (loading || !data.getTicketSellersReport) {
          return
        }
        const { getTicketSellersReport } = data
        this.orders = getTicketSellersReport.filter(o =>
          [OrderStatusEnum.SUCCESSFUL, OrderStatusEnum.REFUND_REQUESTED].includes(o.status),
        )
        this.now = new Date()
        this.totalSoldCount = getTicketSellersReport.reduce((sum, order) => sum + order.count, 0)
        this.cashReport = getTicketSellersReport.filter(r => r.paymentType === 'CASH')
        this.cardReport = getTicketSellersReport.filter(
          r => r.paymentType === 'CARD' && (!r.buyer || r.buyer.paymentType === 'CARD'),
        )
        this.otherReport = getTicketSellersReport.filter(
          r =>
            ['OTHER', 'KEKS10', 'TELEGRAM20'].includes(r.paymentType) ||
            ['KEKS10', 'TELEGRAM20'].includes(r.buyer && r.buyer.paymentType) ||
            ['CASH20', 'CASH20', 'CARD20', 'CARD50'].includes(r.buyer && r.buyer.paymentType),
        )
        this.totalSoldAmount = getTicketSellersReport.reduce(
          (sum, order) => sum + order.totalPrice,
          0,
        )
      },
    },
    me: {
      query: GET_LOGGED_USER,
      result({ data, loading }) {
        if (!loading && data) {
          const { me: user } = data
          this.seller = user
          const now = new Date()
          this.reportId = `${user.id}${now.getDate()}${now.getMonth() + 1}${
            now.getHours() * 60 + now.getMinutes()
          }`
        }
      },
    },
  },
}
</script>

<style scoped>
* {
  box-sizing: border-box;
  margin: 0;
  padding: 0;
}

html,
body {
  height: 100%;
}

main {
  border-right: 0.11111in dashed #0277bd;
  height: 100%;
  margin-right: 1.333333in;
  padding: 0.33333in 0.22222in 0.33333in 0.44444in;
}

header {
  display: flex;
  justify-content: space-between;
  margin-bottom: 0.33333in;
}

header img {
  height: 0.33333in;
}

header span {
  font-family: 'Source Sans Pro', sans-serif;
  font-size: 0.13889in;
  line-height: 120%;
  text-align: right;
  color: #979797;
}

dl {
  margin-bottom: 0.33333in;
}

dl dt {
  font-family: 'Source Sans Pro', sans-serif;
  font-size: 0.11111in;
  line-height: 120%;
  color: #979797;
  margin-bottom: 0.02777in;
}

dl dd {
  font-family: 'Source Sans Pro', sans-serif;
  font-size: 0.13889in;
  line-height: 120%;
  color: #666666;
}

dl dd + dt {
  margin-top: 0.11111in;
}

h1 {
  font-family: 'Raleway', sans-serif;
  font-weight: 800;
  font-size: 0.25in;
  line-height: 120%;
  letter-spacing: -0.03em;
  font-feature-settings: 'pnum' on, 'lnum' on;
  color: #333333;
}

.event-title {
  font-family: 'Raleway', sans-serif;
  font-weight: 800;
  font-size: 0.25in;
  line-height: 120%;
  letter-spacing: -0.03em;
  font-feature-settings: 'pnum' on, 'lnum' on;
  color: #979797;
  margin-bottom: 0.11111in;
}

.sale-period {
  font-family: 'Raleway', sans-serif;
  font-weight: 600;
  font-size: 0.16777in;
  line-height: 120%;
  letter-spacing: -0.03em;
  font-feature-settings: 'pnum' on, 'lnum' on;
  color: #979797;
  margin-bottom: 0.33333in;
}

table {
  width: 100%;
  font-family: 'Source Sans Pro', sans-serif;
  font-size: 0.13889in;
  line-height: 120%;
  color: #333333;
  border-collapse: collapse;
}

table thead {
  background: #e6f1f8;
}

table th {
  font-weight: normal;
  color: #0277bd;
}

table th,
table td {
  padding: 0.08333in 0.11111in;
}

table th:nth-child(-n + 3),
table tbody td:nth-child(-n + 3) {
  text-align: left;
}

table th:nth-child(n + 4),
table tbody td:nth-child(n + 4) {
  text-align: right;
}

table tfoot {
  background: #e6f1f8;
}

table tfoot td {
  color: #0277bd;
  text-align: right;
}

table tr:nth-child(even) {
  background: #f5f5f5;
}

.vat-info {
  font-family: 'Source Sans Pro', sans-serif;
  font-size: 0.11111in;
  line-height: 120%;
  color: #666666;
  margin-top: 0.33333in;
  text-align: right;
}
</style>
